import React, { useState } from "react";
import Field from "app/components/Elements/Field";

import "./styles.scss";

interface IFormData {
  email: string;
  password: string;
}

interface IProps {
  onSubmit: (data: IFormData) => void;
  isLoading: boolean;
  isSignFail: boolean;
  errors: any;
}

const SignInForm: React.FC<IProps> = props => {
  const [state, setState] = useState({ email: "", password: "" });

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    props.onSubmit(state);
  };

  return (
    <form onSubmit={handleSubmit} className="sigin-form">
      <Field
        type="email"
        value={state.email}
        name="email"
        placeholder="емайл"
        onChange={onChange}
        disabled={props.isLoading}
      />
      <Field
        type="password"
        value={state.password}
        name="password"
        placeholder="пароль"
        onChange={onChange}
        disabled={props.isLoading}
      />
      <button className="signin-form__button">Войти</button>
      {props.isSignFail && (
        <div className="errors">
          {Object.keys(props.errors).length === 0 ? (
            <div>Ошибка сервера</div>
          ) : (
            props.errors.map((error: any) => (
              <div key={error.msg}>{error.msg}</div>
            ))
          )}
        </div>
      )}
    </form>
  );
};
export default SignInForm;
